/* eslint-disable @typescript-eslint/camelcase */
export const FBPixelEventName = {
    EVENT_EF1: 'AddToCart',
    EVENT_EF2: 'AddPaymentInfo',
    EVENT_EF3: 'InitiateCheckout',
    COMPLET_EREGISTRATION: 'CompleteRegistration',
    PAGE_VIEW: 'PageView',
};
export class FBPixelClient {
    constructor(pixelId) {
        Object.defineProperty(this, "pixelId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.pixelId = pixelId;
        this.loadScript();
    }
    loadScript() {
        const script = document.createElement('script');
        script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${this.pixelId}');
        `;
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
        <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=534332050284527&ev=PageView&noscript=1"
        />
        `;
        document.getElementsByTagName('head')[0].appendChild(script);
        document.getElementsByTagName('head')[0].appendChild(noscript);
    }
    // https://www.facebook.com/business/help/1549524211985335?helpref=faq_content
    trackEvent(eventName, eventId) {
        fbq('track', eventName, {}, { event_id: eventId });
    }
}
